import React from "react";

import _ from "lodash";
import { change, touch } from "redux-form";

import { FileBox, FakeInputBox } from "./Components";

import type { FieldProps } from "redux-form";

const SIFormMultiFileInput = ({ input, meta }: FieldProps) => {
  // Inside here we will always treat the current input value as an Array.
  const currFiles = input.value ? input.value : [];
  // We are hiding the real file input, so we need 2 things:
  // 1) a reference to the real file input
  // $FlowFixMe
  const realFileInput: {
    current: HTMLDivElement;
  } = React.createRef();

  // 2) a function that generates a click on the real file input
  const onClick = () => {
    if (meta && meta.submitting) {
      return;
    }

    realFileInput.current.click();
    setTimeout(() => {
      meta.dispatch(touch(meta.form, input.name));
    }, 300);
  };

  const onChangeMultiple = (e) => {
    const newFiles = [];
    [...e.target.files].forEach((file) => newFiles.push(file));

    const mergedFileList = _.unionBy(currFiles, newFiles, (file) => file.name);

    input.onChange(mergedFileList);
  };

  const clearFile = (name) => {
    if (meta && meta.submitting) {
      return;
    }

    const newFiles = currFiles.filter((file) => file.name !== name);
    meta.dispatch(change(meta.form, input.name, newFiles));

    if (newFiles.length === 0) {
      realFileInput.current.value = "";
    }
  };

  return (
    <>
      {input.value && input.value.map((file) => <FileBox key={file.name} mb={2} file={file} onRemove={() => clearFile(file.name)} />)}
      <FakeInputBox
        buttonText={currFiles.length === 0 ? "Select file(s)" : "Add more files"}
        placeholderText="Select file(s)"
        onAddClick={onClick}
        meta={meta}
      />
      <input
        style={{
          display: "none",
        }}
        type="file"
        onChange={onChangeMultiple}
        ref={realFileInput}
        multiple
      />
    </>
  );
};

export default SIFormMultiFileInput;
